// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__3kVbO","success":"AnswerItem_success__gTnap","error":"AnswerItem_error__1hwWK"};